import { render, staticRenderFns } from "./approval-status-icon.vue?vue&type=template&id=e6b0311e"
import script from "./approval-status-icon.vue?vue&type=script&lang=js"
export * from "./approval-status-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports